import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select
} from '@material-ui/core';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl, employers } from '../../../utils/constants';
import Scrollbar from '../../Scrollbar';
import SearchNotFound from '../../SearchNotFound';
import { ClientListHead } from '../../_dashboard/clients';
import Controls from '../../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'acc', label: 'EC #', alignRight: true },
  { id: 'memname', label: 'Member Name', alignRight: false },
  { id: 'ages', label: 'Age', alignRight: true },
  { id: 'gen', label: 'Gender', alignRight: true },
  { id: 'Totade', label: 'Joining Date', alignRight: true },
  { id: 'tod', label: 'Retire Date', alignRight: true },
  { id: 'bals', label: 'District', alignRight: false },
  { id: 'stat', label: 'Station', alignRight: false }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function DistrictBreakdown() {
  const m = moment();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(1);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docType, setDocType] = useState('pdf');
  const [groupId, setGroupId] = useState(1);
  const [selectedDistrict, setSelectedDistrict] = useState('All Districts');
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [districtList, setDistrictList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const filename = `MembersByProvinceDistrict_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  const classes = useStyles();
  const group = Number(sessionStorage.getItem('province'));

  useEffect(() => {
    // getProviderClaims();
    if (group > 0) {
      setGroupId(group);
    }
    populateDistrictList(groupId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  useEffect(() => {
    console.log('groupId in useEffect', groupId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districtList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openView = () => {
    navigate('/clientportfolio/portfolio');
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const GetDistrictBreakdown = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/client/GetDistrictBreakdown?type=1&province=${groupId}&district=${selectedDistrict}&branch=a&status=1`
    )
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned GetMembership Summary list', result);
          setDataList(result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error getting GetMembership!: ${error}`, 'error');
        }
      );
  };

  const downloadDocument = () => {
    setLoading(true);
    fetch(
      `${baseUrl}/api/report/getnew/DistrictBreakdown/${docType}/${selectedDistrict}/1/${groupId}/0/1`
    )
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Downloading Claims by Provider!: ${error}`, 'error');
        }
      );
  };

  const populateDistrictList = async (group) => {
    setLoading(true);
    await axios(
      `${baseUrl}/api/client/GetDistrictsClassified?province=${group}&district='aa'`
    ).then(
      (result) => {
        console.log('returned GetDistrictsClassified', result);
        setDistrictList(result.data.result);
        setLoading(false);
      },
      (error) => {
        notifyPopup(`Error in getting students!: ${error}`, 'error');
      }
    );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={1}>
        <Grid item xs={5} sm={3}>
          <Typography component="span" variant="h4" gutterBottom>
            Members By District
          </Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl className={classes.formControl}>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              value={docType}
              size="small"
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl className={classes.formControl} fullWidth>
            <InputLabel id="selectGroupc">Group Name</InputLabel>
            <Select
              labelId="selectGrouplabel"
              id="groupId"
              value={groupId}
              fullWidth
              disabled={group > 0}
              size="small"
              onChange={(e) => {
                setGroupId(e.target.value);
                populateDistrictList(e.target.value);
              }}
            >
              <MenuItem value="1">Bulawayo</MenuItem>
              <MenuItem value="2">Masvingo</MenuItem>
              <MenuItem value="3">Mat North</MenuItem>
              <MenuItem value="4">Mat South</MenuItem>
              <MenuItem value="5">Harare</MenuItem>
              <MenuItem value="6">Midlands</MenuItem>
              <MenuItem value="7">Mash West</MenuItem>
              <MenuItem value="8">Mash Central</MenuItem>
              <MenuItem value="9">Mash East</MenuItem>
              <MenuItem value="10">Manicaland</MenuItem>
              <MenuItem value="11">Head Office</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="district">District</InputLabel>
            <Select
              id="selectedDistrict"
              value={selectedDistrict}
              name="selectedDistrict"
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                setSelectedDistrict(e.target.value);
              }}
            >
              <MenuItem key="All Districts" value="All Districts">
                All Districts
              </MenuItem>
              {districtList.map((item) => (
                <MenuItem key={item.description} value={item.description}>
                  {item.description}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => GetDistrictBreakdown()}
          >
            Refresh
          </Button>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Download
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      ecNumber,
                      surname,
                      firstName,
                      age,
                      gender,
                      joiningDate,
                      retirementDate,
                      dist,
                      station
                    } = row;
                    const isItemSelected = selected.indexOf(ecNumber) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={ecNumber}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />

                        <TableCell align="right">{ecNumber}</TableCell>
                        <TableCell align="left">
                          {surname}, {firstName}
                        </TableCell>
                        <TableCell align="right">{age}</TableCell>
                        <TableCell align="right">{gender}</TableCell>
                        <TableCell align="right" component="th" scope="row" padding="none">
                          {moment(joiningDate).isValid()
                            ? moment(joiningDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="right" component="th" scope="row" padding="none">
                          {moment(retirementDate).isValid()
                            ? moment(retirementDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{dist}</TableCell>
                        <TableCell align="left">{station}</TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isListEmpty && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
